import React from 'react'
import {Document, Page, View} from "@react-pdf/renderer";
import {PaymentInformationPDF} from "../../components/PaymentInformationPDF";

import { baseStyles} from "../../styles";
import {AmountDueAtSigningPDF} from "../../components/AmountDueAtSigningPDF";
import {TaxInformationPDF} from "../../components/TaxInformationPDF";
import {VehicleInfoPDF} from "../../components/VehicleInfoPDF";
import {ResidualInformationPDF} from "../../components/ResidualInformationPDF";
import {MileageInformationPDF} from "../../components/MileageInformationPDF";
import {HeaderPDF} from "../../components/HeaderPDF";
import {FeeBreakdownPDF} from "../../components/FeeBreakdownPDF";
import {CapitalizedCostBreakdownPDF} from "../../components/CapitalizedCostBreakdownPDF";
import {BasePDF} from "../../BasePDF";
import {FooterPDF} from "../../components/FooterPDF";


export const CustomerDisclosurePDF = ( {companyName, customerName, customerAddress, dealState, ...props } ) => {
    return (
        <BasePDF dealState={dealState} {...props}>
            <Document>
                <Page size="A4" style={baseStyles.page} wrap={false}>

                    <HeaderPDF
                        pdfName={'Customer Worksheet'}
                        companyName={companyName}
                        customerName={customerName}
                        customerAddress={customerAddress}
                    />

                    <VehicleInfoPDF/>

                    <View style={{...baseStyles.tablesLayout}}>
                        <View style={{...baseStyles.flexColumn, ...baseStyles.leftColumn}}>
                            <AmountDueAtSigningPDF/>
                            <PaymentInformationPDF />
                            <CapitalizedCostBreakdownPDF isCustomerWorksheet={true}/>
                        </View>

                        <View style={{...baseStyles.flexColumn, ...baseStyles.rightColumn}}>
                            <TaxInformationPDF/>
                            <MileageInformationPDF/>
                            <ResidualInformationPDF isDealerDisclosure={false}/>
                            <FeeBreakdownPDF/>
                        </View>
                    </View>
                    <FooterPDF/>
                </Page>
            </Document>
        </BasePDF>
    )
}